import type { UseQueryOptions, UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { TExpectedDecisionMaker } from 'api/types/edm';
import type { IRequestException } from 'api/types/requestException';

interface IUpdateEdmProps
    extends UseQueryOptions<TExpectedDecisionMaker, IRequestException> {
    data: Partial<TExpectedDecisionMaker>;
    id: number;
}

export const updateEDM = async ({ data, id }: IUpdateEdmProps) => {
    const response = await apiClient.put(`edms/${id}`, {
        json: {
            ...data,
        },
    });
    return (await response.json()) as TExpectedDecisionMaker;
};

export const useUpdateEdmMutation = (
    options: UseMutationOptions<
        TExpectedDecisionMaker,
        IRequestException,
        IUpdateEdmProps
    >
) => {
    return useMutation<
        TExpectedDecisionMaker,
        IRequestException,
        IUpdateEdmProps
    >(async (data) => await updateEDM(data), options);
};
